export default {
    rule: '活动规则',
    text1: '投资组合收益榜',
    text2: '去了解',
    text3: '港股',
    text4: '美股',
    text5: '基金',
    text6: '组合成立天数',
    text7: '累计收益率',
    text8: '日涨跌幅',
    text9: '查看完整榜单',
    text10: '免责声明',
    text11: '以上优惠受条款约束且不与其他活动同时享受优惠，并由复星财富国际控股有限公司(“复星财富”)的全资子公司复星国际证券有限公司（“复星国际证券”）提供，复星国际证券保留随时修改或取消优惠之权利而不作另行通知。如有任何争议，复星国际证券保留最终决定权。本广告不构成任何证券、金融产品或工具的邀约、招揽、建议或任何保证。本广告由复星国际证券提供，内容并未经香港证券及期货事务监察委员会审阅。投资者应注意，投资涉及风险，投资产品价格可升可跌。投资前请充分理解投资风险，并咨询专业顾问（如有需要）。',
    text12: '领取成功',
    text13: '立即使用',
    text14: '温馨提示',
    text15: '感谢您的支持，活动仅限特定渠道且未交易投资组合的客户参与',
    text16: '查看更多精选组合',
    text17: '限时领500HKD免佣券',
    text18: '活动已结束',
    text19: '领取失败，请稍后重试',
    text20: '策略解读：',
    text21: '限时领免佣券',
    text22: '领券可享免佣交易',
    text23: '投资组合，您的投资利器，现限时可领500HKD免佣券。',
    text24: '登录即可查看详情',
    text25: '登录即可领券',
    text26: '活动时间',
    text27: '同市场免佣券正在使用中，不可重复使用，具体前往卡券中心查看',
    text28: '立即登录',
    text29: '立即开户',
    text30: '未知错误',
    text31: '感谢您的支持，活动仅限特定渠道客户参与',
    phonePlaceholder: '请输入手机号',
    codePlaceholder: '请输入验证码',
    readText: '我已阅读并同意',
    userRule: '用户协议、',
    privateRule: '隐私声明',
    captureText1: '获取验证码',
    captureText2: '秒后重新获取',
    captureText3: '重新获取',
    agreeRule: '请选择协议',
    errorText1: '验证码错误，请重新输入',
    label1: '姓名',
    label2: '电话',
    label3: '邮箱',
    label4: '预约时间',
    label5: '出发地',
    label6: '年龄',
    label7: '性别',
    placeholder1: '请输入姓名',
    placeholder2: '请输入电话',
    placeholder3: '请输入邮箱(选填)',
    placeholder4: '请选择时间',
    placeholder5: '请输入出发城市',
    placeholder6: '请选择年龄',
    btn: '确认提交',
    ym: '{y}年{m}月',
    closeText: '关闭',
    cydq: '常用地区',

    openText1: '您已开户，可前往APP了解更多',
    openText2: '去开户',
    openBtnText1: '下载APP',
    openBtnText2: '去开户',
    downloadApp: '前往APP',
    openText3: '继续开户领取福利',
    validatorText: '60s内无须重复获取验证码',
    enterCorrectEmail: '请输入正确的邮箱格式',
    boy: '男',
    girl: '女',
    had: '是',
    no: '否',
    pageTitle: '复星国际证券开户',
    ycj: '您已参加过同类型活动，不可重复参与',
    iknow: '知道了',
    firstk: '完成首笔投资组合交易即可领',
}
